import { __assign } from "tslib";
import { Platform } from 'react-native';
var fontConfig = {
  web: {
    regular: {
      fontFamily: '"Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: '400'
    },
    medium: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      ontWeight: '500'
    },
    light: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      ontWeight: '300'
    },
    thin: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: '100'
    }
  },
  ios: {
    regular: {
      fontFamily: 'System',
      fontWeight: '400'
    },
    medium: {
      fontFamily: 'System',
      fontWeight: '500'
    },
    light: {
      fontFamily: 'System',
      fontWeight: '300'
    },
    thin: {
      fontFamily: 'System',
      fontWeight: '100'
    }
  },
  default: {
    regular: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: 'normal'
    },
    medium: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: 'normal'
    },
    light: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: 'normal'
    },
    thin: {
      fontFamily: '"HalenoirCompactText-Regular", "Open Sans","-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Helvetica Neue","Arial,sans-serif","Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
      fontWeight: 'normal'
    }
  }
};
export default function configureFonts(config) {
  var fonts = Platform.select(__assign(__assign({}, fontConfig), config));
  return fonts;
}